import endpoints from '../../utils/endpoints';

export const getAccountsPage = ({ page, search, size, paymentType }) => {
	const endpoint = endpoints.getLcvAccounts;
	const uri = endpoint.resolve({
		page,
		search,
		size,
		paymentType,
	});

	const { x_bpi_version, method } = endpoint;
	return {
		method,
		uri,
		x_bpi_version,
	};
};
export const getPayeesPage = ({ page, search, size, benType }) => {
	const endpoint = endpoints.getLcvPayees;
	const uri = endpoint.resolve({
		page,
		search,
		size,
		benType,
	});

	const { x_bpi_version, method } = endpoint;
	return {
		method,
		uri,
		x_bpi_version,
	};
};
